import { render, staticRenderFns } from "./HonorSystem.vue?vue&type=template&id=3a74500c&scoped=true&"
import script from "./HonorSystem.vue?vue&type=script&lang=js&"
export * from "./HonorSystem.vue?vue&type=script&lang=js&"
import style0 from "./HonorSystem.vue?vue&type=style&index=0&id=3a74500c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a74500c",
  null
  
)

export default component.exports